import { motion } from "framer-motion";
import { HOW_WE_WORK } from "../../constants/siteData";

export const HowWeWork = () => {
  return (
    <section
      id="process"
      className="relative bg-navy py-24 md:py-32 overflow-hidden"
      data-testid="process-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="kicker mb-5">How we work</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tighter text-cream mb-6">
              Simple.<br />Fast.<br /><span className="text-coral">Reliable.</span>
            </h2>
            <p className="text-white/60 max-w-md">
              Three steps to get your shelves stocked with the world's best-loved FMCG brands.
            </p>
          </div>

          <div className="lg:col-span-8 relative">
            {/* Vertical connector line */}
            <div className="absolute left-6 md:left-8 top-0 bottom-0 w-[2px] bg-gradient-to-b from-coral via-coral/40 to-transparent hidden md:block" />

            <div className="flex flex-col gap-6 md:gap-8">
              {HOW_WE_WORK.map((step, i) => (
                <motion.div
                  key={step.step}
                  initial={{ opacity: 0, x: 40 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.15 }}
                  className="relative flex gap-6 md:gap-10 items-start"
                  data-testid={`process-step-${i}`}
                >
                  <div className="shrink-0 w-12 h-12 md:w-16 md:h-16 rounded-full bg-coral text-navy font-display text-lg md:text-xl flex items-center justify-center z-10 shadow-[0_0_0_6px_rgba(10,25,47,1)]">
                    {step.step}
                  </div>
                  <div className="flex-1 p-6 md:p-8 border hairline rounded-2xl bg-white/[0.02]">
                    <h3 className="font-display text-2xl md:text-3xl text-cream mb-3">
                      {step.title}
                    </h3>
                    <p className="text-white/60 leading-relaxed">{step.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
